// ============================================================
// src/core/logger.js
// Logger centralizado del proyecto
// ============================================================

const LOGGER_NAMESPACE = '[GestorConcursos]';

function _timestamp() {
  return new Date().toISOString();
}

function _formatearContexto(contexto) {
  if (!contexto) return '';
  if (typeof contexto === 'string') return contexto;
  return JSON.stringify(contexto);
}

function _buildPrefix(nivel, modulo = '') {
  const partes = [LOGGER_NAMESPACE, nivel];

  if (modulo) {
    partes.push(`[${modulo}]`);
  }

  partes.push(_timestamp());

  return partes.join(' ');
}

function _emitir(metodo, nivel, modulo, mensaje, contexto) {
  const prefix = _buildPrefix(nivel, modulo);
  const ctx = _formatearContexto(contexto);

  if (ctx) {
    console[metodo](`${prefix} ${mensaje}`, contexto);
    return;
  }

  console[metodo](`${prefix} ${mensaje}`);
}

export function logInfo(modulo, mensaje, contexto = null) {
  _emitir('log', 'INFO', modulo, mensaje, contexto);
}

export function logWarn(modulo, mensaje, contexto = null) {
  _emitir('warn', 'WARN', modulo, mensaje, contexto);
}

export function logError(modulo, mensaje, contexto = null) {
  _emitir('error', 'ERROR', modulo, mensaje, contexto);
}

export function logDebug(modulo, mensaje, contexto = null) {
  _emitir('debug', 'DEBUG', modulo, mensaje, contexto);
}